var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app","data-theme":_vm.themeMode}},[_c('router-view',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(  this.$t(_vm.$route.meta.titleKey)  +' '+ this.$t('h.common.webSuffix')),expression:"  this.$t($route.meta.titleKey)  +' '+ this.$t('h.common.webSuffix')"}]})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e363812","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 349
// module chunks = 0